<template>
  <v-row
    justify="center"
    style="display: none"
  >
    <v-dialog
      v-bind="$attrs"
      v-model="dialog"
      persistent
      max-width="512"
    >
      <v-card>
        <v-card-title class="headline">
          <slot name="header" />
        </v-card-title>
        <v-card-text>
          <slot name="content" />
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1" />
          <slot name="buttons">
            <v-btn
              color="primary"
              text
              @click="cancel"
            >{{ $i18n.t('dialog.confirmation.no') }}</v-btn>
            <v-btn
              color="primary"
              text
              @click="confirm"
            >{{ $i18n.t('dialog.confirmation.yes') }}</v-btn>
          </slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    dialog: {
      required: true,
      type: Boolean
    }
  },
  methods: {
    confirm() {
      this.$emit('success');
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style>
.v-card__title > h1 {
  font-size: 24px !important;
}
</style>
